// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const wallet: GlobalValidator = createValidator(
  "crypto.wallet",
  44,
);

export default wallet;
export const compact = wallet.compact;
export const format = wallet.format;
export const validate = wallet.validate;
